import { motion } from "framer-motion";
import { FiArrowUpRight, FiZap } from "react-icons/fi";

const impactImages = [
  {
    src: "/images/optimized/IMG_7418.jpg",
    alt: "Apple Developer Academy collaboration",
  },
  {
    src: "/images/optimized/timcook.webp",
    alt: "Apple Developer Academy event",
  },
  {
    src: "/images/optimized/appleacademy.webp",
    alt: "Apple Developer Academy certificate",
  },
  {
    src: "/images/optimized/scapeinout.webp",
    alt: "ScapeInOut audio game interface",
  },
];

const magicImages = [
  {
    src: "/images/optimized/books.webp",
    alt: "Italian ancient books from the MAGIC project",
  },
  {
    src: "/images/optimized/conf.webp",
    alt: "MAGIC project presentation",
  },
  {
    src: "/images/optimized/magic-team.webp",
    alt: "MAGIC project team",
  },
];

const impactStories = [
  {
    id: "apple-academy",
    title: "Apple Developer Academy",
    images: impactImages,
    description:
      "During my participation in the Apple Developer Academy, we collaborated with the UICI to develop ScapeInOut, an audio game designed for visually impaired people. The project focused on accessible interaction through sound and haptic feedback.",
    href: "https://apps.apple.com/it/app/scape-inout/id6449718680",
    linkLabel: "View Scape InOut",
  },
  {
    id: "magic",
    title: "MAGIC project",
    images: magicImages,
    description:
      "Through the MAGIC project, we digitalized Italian ancient books and manuscripts and then carried out research on the resulting digital material. I worked on the digitalization workflow, including bleed-through removal to improve the readability and quality of the pages for further analysis.",
    href: "https://www.magic.unina.it",
    linkLabel: "Visit MAGIC project",
  },
];

function Impact() {
  return (
    <section id="impact" className="section-shell">
      <div className="section-heading">
        <div>
          <p className="section-title">Impacts</p>
        </div>
        <span className="section-icon" aria-hidden="true"><FiZap /></span>
      </div>

      <div className="impact-bento">
        {impactStories.map((story, index) => (
          <motion.article
            key={story.id}
            className={`impact-bento-card impact-bento-card--${story.id}`}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.45, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="impact-bento-header">
              <h3 className="impact-bento-title">{story.title}</h3>
              <p className="impact-bento-copy">{story.description}</p>
            </div>

            <div className="impact-bento-visual" role="group" aria-label={`${story.title} gallery`}>
              {story.images.map((image, imageIndex) => (
                <figure key={image.src} className={`impact-bento-image impact-bento-image--${imageIndex + 1}`}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    loading="lazy"
                    decoding="async"
                  />
                </figure>
              ))}
            </div>

            <a
              href={story.href}
              target="_blank"
              rel="noopener noreferrer"
              className="impact-bento-link"
            >
              {story.linkLabel}
              <FiArrowUpRight aria-hidden="true" />
            </a>
          </motion.article>
        ))}
      </div>
    </section>
  );
}

export default Impact;
